import React from "react";
import styled from "styled-components";
import { useAmazonContext } from "../Contexts/AmazonContext";

const LessonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #8747d4;
  font-family: "Quicksand", sans-serif;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  animation: ${props => props.lessons > 0 ? 'pulse 2s infinite' : 'none'};

  i {
    font-size: 20px;
    color: #8747d4;
  }

  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
  }
`;

const LessonsNumber = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #8747d4;
`;

const LessonCountDisplay = ({ onClick }) => {
  const { totalLessons } = useAmazonContext();

  return (
    <LessonsContainer onClick={onClick}>
      <IconWrapper lessons={totalLessons}>
        <i className="fa-solid fa-graduation-cap"></i>
      </IconWrapper>
      <LessonsNumber>{totalLessons}</LessonsNumber>
    </LessonsContainer>
  );
};

export default LessonCountDisplay; 